// extracted by mini-css-extract-plugin
export default {"toastContainer":"IQwL0rS","toastMobile":"YrxtFsY","toastDesktop":"VFR7gZf"};